import React from 'react';
import Collapse from '@mui/material/Collapse';
import AddRoundedIcon from '@mui/icons-material/AddRounded';

const ServiceSection = (props: { title: string; detail: React.ReactNode }) => {
  const { title, detail } = props;
  const [checked, setChecked] = React.useState(true);

  return (
    <>
      <div className="border-b border-web-tertiary">
        <button
          className="bg-transparent py-8 flex justify-between w-full text-xl font-semibold"
          onClick={() => setChecked(!checked)}
        >
          {title}
          <AddRoundedIcon
            className={`ml-4 transition-all duration-300 ${checked ? 'rotate-45' : ''}`}
          />
        </button>
        <Collapse in={checked} timeout={300}>
          <div className="pb-8">{detail}</div>
        </Collapse>
      </div>
    </>
  );
};

export default ServiceSection;
